/* Shift: quick-add cards (Complete the look + exit pop-up). Loaded by each section; runs once. */
(function () {
  if (window.ShiftQA) return;
  window.ShiftQA = true;

  function data(card) {
    if (!card._sq) {
      var el = card.querySelector('[data-sq-json]');
      try { card._sq = JSON.parse(el.textContent); } catch (e) { card._sq = []; }
    }
    return card._sq;
  }
  function colourIndex(card) { return parseInt(card.dataset.colourIndex, 10); }
  function selectedColour(card) {
    var b = card.querySelector('[data-sq-colour][aria-pressed="true"]');
    return b ? b.dataset.sqColour : null;
  }
  function wanted(card) {
    var ci = colourIndex(card), want = [];
    var colour = selectedColour(card);
    var selects = card.querySelectorAll('[data-sq-opt]');
    var complete = true;
    selects.forEach(function (s) { if (!s.value) complete = false; want[parseInt(s.dataset.sqOpt, 10)] = s.value; });
    if (ci >= 0) {
      if (colour === null && card.dataset.fixedColour) colour = card.dataset.fixedColour;
      if (colour === null) {
        var first = data(card)[0];
        colour = first ? first.o[ci] : null;
      }
      want[ci] = colour;
    }
    return { want: want, complete: complete };
  }
  function match(card, want) {
    return data(card).filter(function (v) {
      for (var i = 0; i < v.o.length; i++) if (want[i] && v.o[i] !== want[i]) return false;
      return true;
    });
  }
  function refresh(card) {
    var w = wanted(card), ci = colourIndex(card);
    var any = match(card, w.want);
    var first = any[0];
    // image + price follow the colour even before a size is picked
    var byColour = ci >= 0 ? data(card).filter(function (v) { return v.o[ci] === w.want[ci]; }) : data(card);
    var shown = first || byColour[0];
    if (shown) {
      var img = card.querySelector('[data-sq-img]');
      if (img && shown.i) { img.removeAttribute('srcset'); img.src = shown.i; }
      var price = card.querySelector('[data-sq-price]');
      if (price) price.innerHTML = shown.p;
      card.querySelectorAll('[data-sq-link]').forEach(function (a) {
        a.href = a.href.split('?')[0] + '?variant=' + shown.id;
      });
    }
    var cn = card.querySelector('[data-sq-colour-name]');
    if (cn && ci >= 0) cn.textContent = w.want[ci] || '';
    // mark sold-out sizes for the chosen colour
    card.querySelectorAll('[data-sq-opt]').forEach(function (s) {
      var idx = parseInt(s.dataset.sqOpt, 10);
      Array.prototype.forEach.call(s.options, function (o) {
        if (!o.value) return;
        var test = w.want.slice(); test[idx] = o.value;
        var avail = data(card).some(function (v) {
          for (var i = 0; i < v.o.length; i++) if (test[i] && v.o[i] !== test[i]) return false;
          return v.a;
        });
        o.disabled = !avail;
        o.textContent = o.value + (avail ? '' : ' (sold out)');
      });
    });
    var btn = card.querySelector('[data-sq-add]');
    var exact = w.complete && any.length === 1 ? any[0] : null;
    card._variant = exact;
    if (!w.complete) { btn.disabled = true; btn.textContent = btn.dataset.labelChoose; }
    else if (!exact || !exact.a) { btn.disabled = true; btn.textContent = btn.dataset.labelSold; }
    else { btn.disabled = false; btn.textContent = btn.dataset.labelAdd; }
  }

  function setColour(card, colour) {
    var found = false;
    card.querySelectorAll('[data-sq-colour]').forEach(function (b) {
      var on = b.dataset.sqColour === colour;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) found = true;
    });
    if (found) refresh(card);
    return found;
  }
  window.ShiftQASetColour = setColour;

  function add(card) {
    var v = card._variant, btn = card.querySelector('[data-sq-add]'), msg = card.querySelector('[data-sq-msg]');
    if (!v) return;
    btn.disabled = true; btn.textContent = '…';
    var drawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: v.id, quantity: 1 }] };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status && res.status !== 200) throw new Error(res.description || res.message || 'Error');
      btn.textContent = btn.dataset.labelAdded + ' ✓';
      try { sessionStorage.setItem('shiftExitShown', '1'); } catch (e) {}
      document.dispatchEvent(new CustomEvent('shift:added', { detail: { card: card } }));
      if (drawer && typeof drawer.renderContents === 'function' && res.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(res);
      } else {
        msg.innerHTML = '<a href="' + root + 'cart">View cart →</a>';
      }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'shift-quick-add', cartData: res });
      }
      setTimeout(function () { refresh(card); }, 2200);
    }).catch(function (err) {
      msg.textContent = err.message || 'Something went wrong. Please try again.';
      refresh(card);
    });
  }

  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-sq-colour]');
    if (sw) { var c = sw.closest('[data-sq-card]'); setColour(c, sw.dataset.sqColour); return; }
    var btn = e.target.closest('[data-sq-add]');
    if (btn) { add(btn.closest('[data-sq-card]')); }
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-sq-opt]')) { var c = e.target.closest('[data-sq-card]'); c.querySelector('[data-sq-msg]').textContent = ''; refresh(c); }
  });
  function initAll() { document.querySelectorAll('[data-sq-card]').forEach(refresh); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
